<template>
  <PartialRenderer :items="getHosts" force-render-items="5" v-slot="{item, index}">
    <host-item :host-index="index" :host="item"></host-item>
  </PartialRenderer>
</template>

<script>
  import PartialRenderer from '../PartialRenderer';
  import HostItem from './HostItem';
  import {mapGetters} from 'vuex';

  export default {
    name: 'hosts-list',
    components: {
      PartialRenderer,
      HostItem
    },
    computed: {
      ...mapGetters(['getHosts'])
    }
  }
</script>